import {
  DATA_USER_ALERT,
  DATA_USER_RELOAD,
  DATA_USER_STORAGE_RESET,
  DATA_USER_UPDATE_WEBLITE,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
} from '@weblite/action/user'
import {
  EVENT_FORCE_UPDATE,
  EventForceUpdatePayload,
} from '@weblite/ts-action/gateway'
import { serverSub } from '$func/subscription'
import { synchronizePersist } from '$func/webApis'
import { fullReload } from '$func/fullReload'
import { forceUpdateWeb } from '$setup/workbox'
import { terminateConnection } from '$setup/ws'

serverSub.subscribe(DATA_USER_RELOAD, fullReload)

serverSub.subscribe(
  DATA_USER_UPDATE_WEBLITE,
  ({ forced }: { forced?: boolean }) => {},
)

// TODO: not used
serverSub.subscribe(DATA_USER_STORAGE_RESET, synchronizePersist)

// TODO: not used
serverSub.subscribe(DATA_USER_ALERT, ({ message }: { message: string }) =>
  // eslint-disable-next-line no-alert
  alert(message),
)

serverSub.subscribe(
  EVENT_FORCE_UPDATE,
  ({ minVersion }: EventForceUpdatePayload) => {
    forceUpdateWeb(minVersion.version)
    terminateConnection()
  },
)
